const LikeType = {
    LIKE: "LikeType.LIKE",
    DISLIKE: "LikeType.DISLIKE",
    NEUTRAL:  "LikeType.NEUTRAL",
};

export default LikeType;
